module.exports = __webpack_public_path__ + "img/google_analytics_icon.d0e3400f.svg";